import { useQuery } from "@tanstack/react-query";
import { leadService } from "../../services/leads";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#6b7280"];

const LeadStats = () => {
  const { data: leads } = useQuery({
    queryKey: ["leads"],
    queryFn: leadService.getAll,
  });

  const statusCounts = {};
  (leads || []).forEach((l) => {
    statusCounts[l.status] = (statusCounts[l.status] || 0) + 1;
  });
  const chartData = Object.entries(statusCounts).map(([name, value]) => ({ name, value }));

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="text-base font-semibold text-gray-900 mb-4">Lead Pipeline</h3>
      {chartData.length > 0 ? (
        <>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={chartData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={3} dataKey="value">
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="mt-3 space-y-2">
            {chartData.map((item, i) => (
              <div key={item.name} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                  <span className="text-gray-600 capitalize">{item.name.replace("_", " ")}</span>
                </div>
                <span className="font-medium text-gray-900">{item.value}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="text-gray-400 text-sm text-center py-8">No leads yet</p>
      )}
    </div>
  );
};

export default LeadStats;
